/**
 * The 日報 categories.
 *
 * QA: "create a universal category listing page for these categories. these
 * categories do not have any subcategories, so the layout will be similar to
 * /finnews?state=empty."
 *
 * Five nav entries that previously fell back to `/features` or borrowed a
 * finnews route now have pages of their own. They share one route and one
 * layout — the finnews empty-state shape (hero + article blocks) — because they
 * differ only in their title.
 */
export type DailyNewsCategory = {
  slug: string;
  label: string;
};

export const DAILYNEWS_CATEGORIES: DailyNewsCategory[] = [
  { slug: "headline", label: "要聞" },
  { slug: "ceoai", label: "CEO AI" },
  { slug: "hknews", label: "港聞" },
  { slug: "cntw", label: "兩岸消息" },
  { slug: "international", label: "EJ Global" },
];

export const DAILYNEWS_SLUGS = DAILYNEWS_CATEGORIES.map((c) => c.slug);

export function getDailyNewsCategory(
  slug: string,
): DailyNewsCategory | undefined {
  return DAILYNEWS_CATEGORIES.find((c) => c.slug === slug);
}

/** Label → its page, for `categoryRoute` and the nav. */
export const DAILYNEWS_ROUTES: Record<string, string> = Object.fromEntries(
  DAILYNEWS_CATEGORIES.map((c) => [c.label, `/dailynews/${c.slug}`]),
);
